
import { Database } from "lucide-react";

interface ExecutedQueriesSectionProps {
  queries: string[];
}

export function ExecutedQueriesSection({ queries }: ExecutedQueriesSectionProps) {
  if (!queries || queries.length === 0) return null;

  return (
    <details className="mt-2 text-xs bg-stone-100 dark:bg-stone-950/40 border border-stone-300 dark:border-stone-800/60 rounded-xl p-3">
      <summary className="cursor-pointer text-[11px] font-mono text-indigo-700 dark:text-indigo-400 font-semibold select-none flex items-center gap-1.5 hover:text-indigo-800 dark:hover:text-indigo-300">
        <Database className="w-3 h-3" />
        <span>Executed SQL Queries ({queries.length})</span>
      </summary>
      <div className="mt-2 space-y-1.5">
        {queries.map((q: string, idx: number) => (
          <pre
            key={idx}
            className="p-2 rounded bg-stone-900 text-stone-100 dark:bg-black/60 dark:text-stone-300 text-[11px] font-mono overflow-x-auto whitespace-pre-wrap border border-stone-800/60"
          >
            {q}
          </pre>
        ))}
      </div>
    </details>
  );
}
